import { Component } from 'react'
import { connect, MapDispatchToPropsFunction } from 'react-redux'
import { Field, FieldValue, formValueSelector, arrayRemove } from 'redux-form'
import * as styles from 'styles/molecules/forms/OnboardingForm.css'
import { FORM_ONBOARDING_PROPERTY } from 'constants/forms'
import { State } from 'interfaces/state'
import { getPurchaseDateOptions } from 'helpers/propertyHelpers'
import { PropertyListChildProps } from 'components/molecules/forms/PropertyList'
import TextButton from 'components/atoms/buttons/TextButton'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import OldSelectWrapped, { OldSelectOwnProps } from 'components/atoms/inputs/OldSelectWrapped'
import { FIELD_CAR_ESTIMATED_PROPS, FIELD_CURRENCY_WRAPPED_PROPS } from 'constants/fields'
import { CarMakeField, CarYearField, CarModelField } from 'components/atoms/inputs/CarFields'
import { isFieldArrayFieldActive } from 'helpers/formHelpers'
import { smoothScrollInfoView } from 'helpers/styleHelpers'

type CarsFormFieldsStateProps = {
  isValueFieldActive: boolean
  isMakeFieldActive: boolean
  canBeRemoved: boolean
  makeValue: number | null
  modelValue: number | null
  yearValue: number | null
}

type CarsFormFieldsDispatchProps = {
  remove: () => void
}

type CarsFormFieldsOwnProps = PropertyListChildProps

type CarsFormFieldsProps = CarsFormFieldsStateProps & CarsFormFieldsDispatchProps & CarsFormFieldsOwnProps

class CarsFormFieldsComponent extends Component<CarsFormFieldsProps> {
  private carsFormFieldsNode: HTMLDivElement | null = null

  render () {
    const {
      name, index, canBeRemoved, remove,
      makeValue, modelValue,
    } = this.props

    const removeButton = canBeRemoved ? (
      <TextButton onClick={ remove }>Delete</TextButton>
    ) : null

    return (
      <div ref={ (el) => this.carsFormFieldsNode = el }>
        <div className={ styles.innerHeader }>
          Car #{ index + 1 }
          { removeButton }
        </div>
        <br />
        <ul className={ styles.controlList }>
          <li className={ styles.controlListItem }>
            <CarMakeField
              theme='snow'
              label='Make'
              name={ `${ name }.make` }
              qaMarker='car-make-input'
            />
          </li>
          <li className={ styles.controlListItem }>
            <CarModelField
              theme='snow'
              label='Model'
              name={ `${ name }.model` }
              make={ makeValue }
              qaMarker='car-model-input'
            />
          </li>
          <li className={ styles.controlListItem }>
            <CarYearField
              theme='snow'
              label='Year'
              name={ `${ name }.year` }
              make={ makeValue }
              model={ modelValue }
              qaMarker='car-year-input'
            />
          </li>
          <li className={ styles.controlListItem }>
            <Field
              name={ `${ name }.purchased_at` }
              props={{
                label: 'Purchase Month/Year',
                options: getPurchaseDateOptions(),
                theme: 'snow',
                qaMarker: 'car-purchased-at-input',
              } as OldSelectOwnProps<string>}
              component={ OldSelectWrapped }
            />
          </li>
          <li className={ styles.controlListItem }>
            <Field
              name={ `${ name }.estimated_value` }
              props={ FIELD_CAR_ESTIMATED_PROPS }
              component={ TextFieldWrapped }
              { ...FIELD_CURRENCY_WRAPPED_PROPS }
            />
          </li>
          <li className={ styles.controlListItem } />
        </ul>
      </div>
    )
  }

  componentDidMount () {
    if (this.props.isMakeFieldActive && this.carsFormFieldsNode) {
      smoothScrollInfoView(this.carsFormFieldsNode)
    }
  }
}

const selector = formValueSelector(FORM_ONBOARDING_PROPERTY)

const CARS_PROPERTY_NAME = 'cars'
const mapStateToProps = (state: State, ownProps: CarsFormFieldsOwnProps): CarsFormFieldsStateProps => {
  const { index } = ownProps
  const form = state.form[FORM_ONBOARDING_PROPERTY]

  const allValues = selector(state, CARS_PROPERTY_NAME) as FieldValue[]
  const values = allValues[index]

  const activeField = form && form.active ? form.active : ''
  const isValueFieldActive = isFieldArrayFieldActive(CARS_PROPERTY_NAME, index, 'estimated_value', activeField)
  const isMakeFieldActive = isFieldArrayFieldActive(CARS_PROPERTY_NAME, index, 'make', activeField)

  const canBeRemoved = allValues.length > 1

  return {
    makeValue: values.make,
    modelValue: values.model,
    yearValue: values.year,
    isValueFieldActive,
    isMakeFieldActive,
    canBeRemoved,
  }
}

const mapDispatchToProps: MapDispatchToPropsFunction<CarsFormFieldsDispatchProps, CarsFormFieldsOwnProps> = (dispatch, ownProps) => ({
  remove: () => dispatch(arrayRemove(FORM_ONBOARDING_PROPERTY, 'cars', ownProps.index)),
})

const CarsFormFields = connect<CarsFormFieldsStateProps, CarsFormFieldsDispatchProps, CarsFormFieldsOwnProps>(
  mapStateToProps, mapDispatchToProps
)(CarsFormFieldsComponent)
export default CarsFormFields
